// Project Details Tab object for type safety
export enum ProjectDetailsTab {
  GENERAL_GUIDANCE = "general-guidance",
  FINANCIAL_DATA = "financial-data",
  TECHNICAL_ASPECTS = "technical-aspects",
  BUDGET = "budget",
  RECOMMENDATIONS = "recommendations",
  ACTIVITY_VIABILITY = "activity-viability",
  ENVIRONMENTAL_REGULARITY = "environmental-regularity",
  PRODUCTION_SYSTEM = "production-system",
  DISBURSEMENT_SCHEDULE = "disbursement-schedule",
  TECHNICAL_REPORT = "technical-report",
  PROJECT_WORKFLOW = "project-workflow",
  DOCUMENTS = "documents",
}

// Sub-tab enums for type safety
export enum FinancialDataSubTab {
  PURPOSE = "purpose",
  BENEFITED_AREA = "benefited-area",
  CULTURE_ACTIVITY = "culture-activity",
  FRAMING = "framing",
  ASTEC = "astec",
}

export enum BudgetSubTab {
  PROJECT_SUPPLIES = "project-supplies",
  PROJECT_SERVICES = "project-services",
  PROJECT_OTHER_SPENDINGS = "project-other-spendings",
}
